'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'user-cowboy';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8ea';
var svgPathData = 'M420.7 36.7c-10.6 10.6-38.6 29.6-83 43.2-9.8-53.7-29.9-111.9-64-111.9-8.9 0-17.7 3.8-25.5 8-7.7 4.2-17.4 8-24.1 8s-16.4-3.8-24.1-8c-7.9-4.3-16.6-8-25.5-8-34.1 0-54.2 58.2-64 111.9-44.4-13.6-72.4-32.5-83-43.2-5.5-5.5-14.3-6.3-20.7-1.7s-8.5 13.1-5 20.1c11.6 23.1 42 57 94.3 80l0 8.9c0 70.7 57.3 128 128 128s128-57.3 128-128l0-8.9c52.3-22.9 82.8-56.8 94.3-80 3.5-7 1.4-15.5-5-20.1s-15.1-3.9-20.7 1.7zm-117 114.5C300.1 192 265.8 224 224 224s-76.1-32-79.7-72.9c23.5 5.6 50 8.9 79.7 8.9s56.2-3.3 79.7-8.9zM180.6 320C89.7 320 16 393.7 16 484.6 16 499.7 28.3 512 43.4 512l361.1 0c15.1 0 27.4-12.3 27.4-27.4 0-90.9-73.7-164.6-164.6-164.6l-86.9 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserCowboy = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;